import "./App.css";
import { Component } from "react";
import Home from "./containers/Home/Home";
import Category from "./containers/Category/Category";
import { Route, Switch, withRouter } from "react-router-dom";
import * as actions from "./store/actions/index";
import "semantic-ui-css/semantic.min.css";
import { connect } from "react-redux";

import AboutUs from "./components/StaticPages/AboutUs/AboutUs";
import CookiePolicy from "./components/StaticPages/CookiePolicy/CookiePolicy";
import PrivacyPolicy from "./components/StaticPages/PrivacyPolicy/PrivacyPolicy";
import ReturnAndRefund from "./components/StaticPages/ReturnRefundCancellation/ReturnRefundAndCancellation";
import ShippingPolicy from "./components/StaticPages/ShippingPolicy/ShippingPolicy";
import TermsAndCondtions from "./components/StaticPages/TermsAndConditions/TermsAndConditions";
import ContactUs from "./components/StaticPages/ContactUs/ContactUs";

import Workouts from "./containers/Workouts/Workouts";
import HomeSections from "./containers/Admin/HomeSections/HomeSections";
import Shop from "./containers/Shop/Shop";
import Collection from "./containers/Collection/Collection";
import MyOrders from "./containers/MyOrders/MyOrders";
import Cart from "./containers/Cart/Cart";
import SpecfifcWorkout from "./containers/SpecificWorkout/SpecificWorkout";
import Product from "./containers/Product/Product";
import Checkout from "./containers/Checkout/Checkout";
import MyBookings from "./containers/Bookings/myBookings";
import Brand from "./containers/Brands/Brand";
//Admin
import Categories from "./containers/Admin/AddCategories/categories";
import Products from "./containers/Admin/AddProducts/products";
import Brands from "./containers/Admin/Brands/brands";
import Attributes from "./containers/Admin/Attributes/attributes";
import AdminTest from "./containers/AdminTest/AdminTest";
import AdminShop from "./containers/Admin/Shop/shop";
// import Collections from "./containers/Admin/Collections/collections";
import Coupon from "./containers/Admin/CouponManagement/coupon";
import WorkoutPlans from "./containers/Admin/WorkoutPlans/workoutPlans";
import AddCarousel from "./containers/Admin/AddCarousel/addCarousel";
import AddBanner from "./containers/Admin/AddBanner/addBanner";
import StaffManagement from "./containers/Admin/StaffManagement/staffManagement";
import OrdersManagement from "./containers/Admin/OrdersManagement/ordersManagement";
import EditProduct from "./containers/Admin/EditProduct/EditProduct";
import SpecificWorkoutContainer from "./containers/Admin/SpecificWorkout/SpecificWorkout";
import Wishlist from "./components/Wishlist/Wishlist";
// import AdminTest from './containers/AdminTest/AdminTest';
import Search from "./containers/Search/Search";
import Auth from "./components/Auth/auth";
import SearchAdmin from "./containers/Admin/SearchAdmin/SearchAdmin";
import AddClient from "./containers/Admin/AddClient/addClient";
import StockManagement from "./containers/Admin/StockManagement/StockManagement";
import ExpiryManagement from "./containers/Admin/ExpiryManagement/ExpiryManagement";
import HomeSectionsSearchProducts from "./containers/Admin/HomeSections/HomeSectionsSearchProducts/HomeSectionsSearchProducts";

// import Coupons from "./containers/Admin/CouponManagement/coupon";
class App extends Component {
  componentDidMount = () => {
    this.props.checkAuthState();
  };
  render() {
    //Non-Auth Users
    let routes = (
      <Switch>
        <Route path="/admin/shop" exact component={AdminShop} />
        <Route path="/admin/banner" exact component={AddBanner} />
        <Route path="/admin/client" exact component={AddClient} />
        <Route path="/admin/editProduct/" exact component={EditProduct} />
        <Route
          path="/admin/editProduct/:productId"
          exact
          component={EditProduct}
        />
        <Route
          path="/admin/search/:searchKey/:suggestion"
          component={SearchAdmin}
        />
        <Route
          path="/admin/homeSections/search/:searchKey/:suggestion/:sectionId"
          component={HomeSectionsSearchProducts}
          exact
        />
        <Route path="/admin/orders" exact component={OrdersManagement} />
        <Route path="/admin/carousel" exact component={AddCarousel} />
        <Route path="/admin/workoutPlans" exact component={WorkoutPlans} />
        <Route path="/admin/homeSections" exact component={HomeSections} />
        <Route path="/admin/coupons" exact component={Coupon} />
        {/* <Route path="/admin/collections" exact component={Collections} /> */}
        <Route path="/admin/attributes" exact component={Attributes} />
        <Route path="/admin/brands" exact component={Brands} />
        <Route path="/admin/products" exact component={Products} />
        <Route path="/admin/categories" exact component={Categories} />

        <Route
          path="/admin/staffManagement"
          exact
          component={StaffManagement}
        />
        <Route
          path="/admin/workouts/:workoutTitle/:workoutId"
          component={SpecificWorkoutContainer}
          exact
        />
        <Route
          path="/admin/stockManagement"
          exact
          component={StockManagement}
        />
        <Route
          path="/admin/expiryManagement"
          exact
          component={ExpiryManagement}
        />
        {/* <Route path="/admin/coupons" exact component={Coupons} /> */}
        <Route path="/adminTest" component={AdminTest} />
        <Route path="/" exact component={Home} />
        <Route path="/authentication" component={Auth} />
        <Route path="/collection" exact component={Collection} />
        <Route path="/aboutUs" component={AboutUs} />
        <Route path="/cookiePolicy" component={CookiePolicy} />
        <Route path="/privacyPolicy" component={PrivacyPolicy} />
        <Route
          path="/returnRefundAndCancellation"
          component={ReturnAndRefund}
        />
        <Route path="/shippingPolicy" component={ShippingPolicy} />
        <Route path="/termsAndConditions" component={TermsAndCondtions} />
        <Route path="/contactUs" component={ContactUs} />

        <Route path="/product/:productName/:productId" component={Product} />
        <Route
          path="/brand/:brandName/:brandId/:productType"
          component={Brand}
        />

        <Route
          path="/workouts/:workoutTitle/:workoutId"
          component={SpecfifcWorkout}
          exact
        />

        <Route path="/workouts" component={Workouts} exact />
        <Route path="/checkout" component={Checkout} />
        <Route
          path="/category/:categoryName/:subcategoryName/:productType/:categoryId/:subcategoryId"
          component={Category}
        />
        <Route
          path="/shop/:subcategoryName/:productType/:categoryId/:subcategoryId"
          component={Shop}
        />
        <Route path="/product/:productName/:productId" component={Product} />
        <Route path="/search/:searchKey/:suggestion" component={Search} />

        {/* <Route path="/" render={() => <h1>Page Not Found :-(</h1>} /> */}
      </Switch>
    );
    if (this.props.isAuthenticated) {
      routes = (
        <Switch>
          <Route
            path="/admin/staffManagement"
            exact
            component={StaffManagement}
          />
          <Route path="/admin/orders" exact component={OrdersManagement} />
          <Route path="/admin/shop" exact component={AdminShop} />
          <Route path="/admin/banner" exact component={AddBanner} />
          <Route path="/admin/client" exact component={AddClient} />
          <Route path="/admin/carousel" exact component={AddCarousel} />
          <Route path="/admin/workoutPlans" exact component={WorkoutPlans} />
          <Route path="/admin/homeSections" exact component={HomeSections} />
          <Route path="/admin/coupons" exact component={Coupon} />
          <Route path="/admin/editProduct/" exact component={EditProduct} />
          <Route
            path="/admin/editProduct/:productId"
            exact
            component={EditProduct}
          />
          <Route
            path="/admin/search/:searchKey/:suggestion"
            component={SearchAdmin}
          />
          {/* <Route path="/admin/collections" exact component={Collections} /> */}
          <Route path="/admin/attributes" exact component={Attributes} />
          <Route path="/admin/brands" exact component={Brands} />
          <Route path="/admin/products" exact component={Products} />
          <Route path="/admin/categories" exact component={Categories} />
          <Route
            path="/admin/workouts/:workoutTitle/:workoutId"
            component={SpecificWorkoutContainer}
            exact
          />
          <Route
            path="/admin/stockManagement"
            exact
            component={StockManagement}
          />
          <Route
            path="/admin/expiryManagement"
            exact
            component={ExpiryManagement}
          />
          <Route path="/myBookings" exact component={MyBookings} />
          <Route path="/wishlist" component={Wishlist} />
          <Route path="/authentication" exact component={Auth} />
          {/* <Route path="/admin/coupons" exact component={Coupons} /> */}
          <Route path="/adminTest" component={AdminTest} />

          <Route path="/" exact component={Home} />
          <Route path="/cart" exact component={Cart} />
          {/* <Route path="/myorders" exact component={MyOrders} /> */}

          <Route path="/collection" exact component={Collection} />
          <Route
            path="/brand/:brandName/:brandId/:productType"
            component={Brand}
          />
          <Route path="/aboutUs" component={AboutUs} />
          <Route path="/cookiePolicy" component={CookiePolicy} />
          <Route path="/privacyPolicy" component={PrivacyPolicy} />
          <Route
            path="/returnRefundAndCancellation"
            component={ReturnAndRefund}
          />
          <Route path="/shippingPolicy" component={ShippingPolicy} />
          <Route path="/termsAndConditions" component={TermsAndCondtions} />
          <Route path="/contactUs" component={ContactUs} />
          <Route path="/product/:productName/:productId" component={Product} />

          <Route
            path="/workouts/:workoutTitle/:workoutId"
            component={SpecfifcWorkout}
            exact
          />
          <Route path="/workouts" component={Workouts} exact />
          <Route path="/checkout" component={Checkout} />
          <Route
            path="/category/:categoryName/:subcategoryName/:productType/:categoryId/:subcategoryId"
            component={Category}
          />
          <Route
            path="/shop/:subcategoryName/:productType/:categoryId/:subcategoryId"
            component={Shop}
          />
          <Route path="/product/:productName/:productId" component={Product} />
          <Route path="/search/:searchKey/:suggestion" component={Search} />
          <Route
            path="/admin/homeSections/search/:searchKey/:suggestion/:sectionId"
            component={HomeSectionsSearchProducts}
            exact
          />
          <Route path="/" render={() => <h1>Page Not Found :-(</h1>} />
        </Switch>
      );
    }
    return (
      <>
        <div>{routes}</div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.userId != null,
  };
};
const mapDisptachToProps = (dispatch) => {
  return {
    checkAuthState: () => dispatch(actions.checkAuthState()),
  };
};
// export default withRouter(connect(mapStateToProps, mapDisptachToProps)(App));

export default connect(mapStateToProps, mapDisptachToProps)(withRouter(App));
